var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading",
          value: _vm.isBusy,
          expression: "isBusy",
        },
      ],
    },
    [
      _c(
        "el-form",
        {
          ref: "form",
          attrs: {
            model: _vm.form,
            rules: _vm.rules,
            "element-loading-spinner": "el-icon-loading",
            "label-width": "170px",
          },
        },
        [
          _c(
            "el-tabs",
            {
              model: {
                value: _vm.activeName,
                callback: function ($$v) {
                  _vm.activeName = $$v
                },
                expression: "activeName",
              },
            },
            [
              _c(
                "el-tab-pane",
                { attrs: { label: "Common", name: "common" } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "Type", prop: "type" } },
                    [
                      _c(
                        "el-select",
                        {
                          attrs: { disabled: _vm.isEditMode },
                          model: {
                            value: _vm.form.type,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "type", $$v)
                            },
                            expression: "form.type",
                          },
                        },
                        _vm._l(_vm.typeList, function ({ value, label }) {
                          return _c("el-option", {
                            key: value,
                            attrs: { value: value, label: label },
                          })
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "Schema", prop: "schema" } },
                    [
                      _c(
                        "el-select",
                        {
                          attrs: { disabled: _vm.isEditMode },
                          model: {
                            value: _vm.form.schema,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "schema", $$v)
                            },
                            expression: "form.schema",
                          },
                        },
                        _vm._l(_vm.schemaOptions, function ({ value, label }) {
                          return _c("el-option", {
                            key: value,
                            attrs: { value: value, label: label },
                          })
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "Slug", prop: "slug" } },
                    [
                      _c("el-input", {
                        attrs: { type: "text", disabled: "" },
                        model: {
                          value: _vm.form.slug,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "slug", $$v)
                          },
                          expression: "form.slug",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "Class", prop: "class" } },
                    [
                      _c("el-input", {
                        attrs: { type: "text", disabled: "" },
                        model: {
                          value: _vm.form.class,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "class", $$v)
                          },
                          expression: "form.class",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "Name", prop: "name" } },
                    [
                      _c("el-input", {
                        model: {
                          value: _vm.form.name,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "name", $$v)
                          },
                          expression: "form.name",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-tab-pane",
                { attrs: { label: "Config", name: "config" } },
                [
                  _c("schema-table", {
                    attrs: { schema: _vm.getConfigSchema, scope: "config" },
                    model: {
                      value: _vm.form.config,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "config", $$v)
                      },
                      expression: "form.config",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-tab-pane",
                { attrs: { label: "URLs", name: "urls" } },
                _vm._l(_vm.providerUrls, function (item) {
                  return _c(
                    "el-form-item",
                    { key: item.name, attrs: { label: item.name } },
                    [
                      _c("el-input", {
                        attrs: { value: item.url, type: "text", readonly: "" },
                      }),
                    ],
                    1
                  )
                }),
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "button",
        { staticClass: "btn btn-purple px-4 mt-3", on: { click: _vm.store } },
        [_vm._v("Store")]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }